import { createContext } from 'react';

const loraContext = createContext();

export default loraContext;